export class Assets {
    static topicPreview: string = new URL("../assets/screenshots/topicPreview.png", import.meta.url).href;
}